import { NavBar } from "../../components/NavBar";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import './style.css';

export function SchedulePage() {
  return (
    <>
      <NavBar>
        <div>
          <div className="page-heading">
            <div>
              <h1>Agenda acadêmica</h1>
              <p>Consulte seus compromissos e datas importantes.</p>
            </div>
          </div>
          <div className="calendar-card surface-card">
            <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            nowIndicator={true}
            height={'auto'}
            allDayText='24 horas'
            columnFormat='dddd'
            header={{
              left: 'prev,next today',
              center: 'title',
              right: 'month,agendaWeek,agendaDay,listMonth'
            }}
            buttonText={{
              today: 'Hoje',
              month: 'Mês',
              week: 'Semana',
              day: 'Hoje',
              list: 'Lista',
            }}
            locale={'pt-BR'}
            />
          </div>
        </div>
      </NavBar>
    </>
  )
}
